export interface ProductFile {
  id: string;
  productCategory: string;
  productName: string;
  fileDataCategories: FileDataCategories;
  imageUrl: string;
  _rid?: string;
  _self?: string;
  _etag?: string;
  _attachments?: string;
  _ts?: number;
}

export interface FileInfo {
  fileName: string;
  fileDescription: string;
  fileExtension: string;
}

export interface FileBlobInfo {
  fileLanguages: string[];
  filePathBlobStorage: string;
  physicalFileName: string;
  fileVersion: string;
  fileDate: string;
}

export interface FileMetaData {
  productId: string;
  version: string;
  fileDate: string;
  fileLanguages: string[];
  ptBR: FileInfo;
  en?: FileInfo;
  es?: FileInfo;
  it?: FileInfo;
  files: {
    fileLanguages: string[];
    filePathBlobStorage: string;
    physicalFileName: string;
  }[];
  fileName: string;
  fileVersion: string;
  filePath?: string;
  fileCategory?: string;
}

export interface FileDataCategories {
  softwares?: FileMetaData[];
  guides?: FileMetaData[];
  manuals?: FileMetaData[];
  others?: FileMetaData[];
  informativos?: FileMetaData[];
}

/** Fixed Cosmos document id holding the flat, product-less list of "Informativos" files. */
export const INFORMATIVOS_DOC_ID = 'informativos';

export interface ProductCategory {
  [key: string]: { ptBR: string; en: string; es: string; it: string };
}

export interface Categories {
  id: string;
  categories: ProductCategory;
}

export interface UploadResponse {
  success: boolean;
  message?: string;
}
export interface CopyResponse {
  success: boolean;
  copiedPath: string;
}
export interface DeleteResponse {
  success: boolean;
  message?: string;
}
export interface OrderedCategory {
  key: string;
  value: (ProductFile & { imageUrl?: string })[];
}

export interface PopulateFormData {
  productId: string;
  fileName: string;
  fileDescription: string;
  filePath: string;
  fileType: string;
  fileSize: number;
  fileVersion: string;
  fileDate: string;
  fileCategoryId: string;
  fileCategory: string;
  physicalFileName: string;
  physicalFilePath: string;
  physicalFileSize: number;
  physicalFileType: string;
  productName: string;
  productCategoryId: string;
  productCategoryName: string;
  productCategory: string;
  version?: string;
  date?: string;
  fileLanguages?: string[];
  translations?: Record<string, { fileName: string; description: string }>;
  files?: { physicalFileName: string; fileLanguages: string[] }[];
}

export interface Language {
  code: string;
  shortCode: string;
  name: string;
  flag: string;
}

export interface ProductOption {
  value: string;
  label: string;
  category: string;
}
export interface FormUploadFileDialogData {
  mode: 'edit' | 'create';
  productId?: string;
  productCategory?: string;
  fileData?: PopulateFormData;
  category?: string;
  physicalFileName?: string;
  physicalFileVersion?: string;
  fileInputs?: FileInput[];
}

export interface FileInput {
  id: string;
  fileName: string;
  fileType: string;
  fileSize: number;
  selectedLanguages: string[];
  file?: File;
}

export interface FileInput {
  id: string;
  fileName: string;
  fileType: string;
  fileSize: number;
  selectedLanguages: string[];
  file?: File;
}

export interface FormUploadFileDialogData {
  fileData?: PopulateFormData;
  category?: string;
  productId?: string;
  fileInputs?: FileInput[];
}

export interface FileInput {
  id: string;
  fileName: string;
  fileType: string;
  fileSize: number;
  selectedLanguages: string[];
  file?: File;
}

export interface FormUploadFileDialogData {
  fileData?: PopulateFormData;
  category?: string;
  productId?: string;
  fileInputs?: FileInput[];
}

export interface FileInput {
  id: string;
  fileName: string;
  fileType: string;
  fileSize: number;
  selectedLanguages: string[];
  file?: File;
}

export interface FormUploadFileDialogData {
  fileData?: PopulateFormData;
  category?: string;
  productId?: string;
  fileInputs?: FileInput[];
}

export interface CategoriesFile {
  id: string;
  categories: Record<
    string,
    { ptBR: string; en: string; es: string; it: string }
  >;
}
